/**
 * @fileOverView
 * @description SubscriptionPortal<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandModel = require('ampersand-model');
var moment = require('moment');
var app = require("ampersand-app");

var SubscriptionPortal = AmpersandModel.extend({

    idAttribute: 'key',

    url: "stripe/v1/portal",

    ajaxConfig: app.utils.setPersonalAuthTokenHeader,

    props: {
        key : 'string',
        sessionUrl: 'string',
    },

    derived: {}
});

module.exports = SubscriptionPortal;
